export default __webpack_public_path__ + "static/media/kalanchoe.faf1b264.jpg";